import ky from 'ky'

import { API_BASE_URL } from './config'

export const apiInstance = ky.create({
  baseUrl: API_BASE_URL,
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})
